/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNotification } from '@/containers'
import { useLightbox } from '@/hooks/useLightBox'
import { IconCheckBlue, Star } from '@/styles/Icon'
import type { ProductReview } from '@/types'
import { getAllProductReview } from '@/utils/endpoint'
import { Tab } from '@headlessui/react'
import dayjs from 'dayjs'
import dynamic from 'next/dynamic'
import type { Dispatch, SetStateAction } from 'react'
import { Fragment, useEffect, useState } from 'react'
import DrawBottom from '../DrawBottom'
import ImageOptimize from '../ImageOptimize'
const StarRatings = dynamic(() => import('react-star-ratings'), {
  ssr: false,
})

interface ModalListReview {
  showModalListReview: boolean
  setShowModalListReview: Dispatch<SetStateAction<boolean>>
  productName: string
  productId: string
  average: number | undefined
  reviewSummary: []
}
interface reviewGalleryType {
  value: string
  _id: string
  index: number
}
const ModalListReview = ({
  showModalListReview,
  productName,
  productId,
  setShowModalListReview,
  average,
  reviewSummary,
}: ModalListReview) => {
  const [listReview, setListReview] = useState<ProductReview[] | undefined>()
  // const [queryParams, setQueryParams] = useState(`productId=${productId}`)
  const [filterItemtReview, setFilterItemReview] = useState<
    ProductReview[] | undefined
  >()
  const { systemConfig } = useNotification()
  const sum = reviewSummary?.reduce((acc, curr) => acc + curr, 0)
  const [reviewGalleryData, setReviewGalleryData] = useState<
    reviewGalleryType[] | string[]
  >([])
  const [indexGallery, setIndexGallery] = useState(-1)
  const { openLightBox, renderLightBox } = useLightbox()
  const filterAttr = [
    { name: 'Mới nhất', type: 0, action: 'sort' },
    { name: 'Có hình ảnh', type: 0, action: 'hasImage' },
    { name: '5 Sao', type: 5, action: 'point' },
    { name: '4 Sao', type: 4, action: 'point' },
    { name: '3 Sao', type: 3, action: 'point' },
    { name: '2 Sao', type: 2, action: 'point' },
  ]
  const breakpoints = [440, 414, 375]

  const newArrayPoint = reviewSummary.map((value, index) => {
    return {
      point: index + 1,
      value: value,
    }
  })
  useEffect(() => {
    getAllProductReview(`productId=${productId}`).then(async result => {
      if (result && !(result instanceof Error)) {
        setListReview(result.data)
        setFilterItemReview(result.data)
        return
      }
      setListReview([])
    })
  }, [])
  function changeDataReview(e: {
    name?: string
    type: number
    action: string
  }) {
    switch (e?.action) {
      case 'sort':
        // setQueryParams(`productId=${productId}&sortBy=createdAt&sortType=desc`)
        getAllProductReview(
          `productId=${productId}&sortBy=createdAt&sortType=desc`
        ).then(async result => {
          if (result && !(result instanceof Error)) {
            setFilterItemReview(result.data)
            return
          }
          setFilterItemReview([])
        })
        break
      case 'hasImage':
        // setQueryParams(`productId=${productId}&hasImage=true`)
        getAllProductReview(`productId=${productId}&hasImage=true`).then(
          async result => {
            if (result && !(result instanceof Error)) {
              setFilterItemReview(result.data)
              return
            }
            setFilterItemReview([])
          }
        )
        break
      case 'point':
        // setQueryParams(`productId=${productId}&point=${e?.type}`)
        getAllProductReview(`productId=${productId}&point=${e?.type}`).then(
          async result => {
            if (result && !(result instanceof Error)) {
              setFilterItemReview(result.data)
              return
            }
            setFilterItemReview([])
          }
        )
        break
      default:
        // setQueryParams(`productId=${productId}&sortBy=createdAt&sortType=desc`)
        getAllProductReview(
          `productId=${productId}&sortBy=createdAt&sortType=desc`
        ).then(async result => {
          if (result && !(result instanceof Error)) {
            setFilterItemReview(result.data)
            return
          }
          setFilterItemReview([])
        })
        break
    }
  }

  const extractedDataImage = listReview
    ?.map((item, index) => {
      const images = item.images.map(value => ({ value, index, _id: item._id }))
      return images
    })
    .flat()
  const openReviewGallery = async (
    data: reviewGalleryType[] | string[],
    index: number
  ) => {
    await setReviewGalleryData(data)
    await setIndexGallery(index)
    openLightBox(0)
  }
  return (
    <DrawBottom
      open={showModalListReview}
      onClose={() => setShowModalListReview(false)}
      title={'Đánh giá'}
      scroll={true}
    >
      <div className='w-full'>
        {listReview && average && (
          <div className='review'>
            <h3 className='mb-3 text-base font-bold tracking-tight text-zinc-800'>
              <span>{productName}</span>
            </h3>
            <div className='overView flex gap-3 rounded-lg bg-white-500 py-3 items-center'>
              <div className='star_average relative max-w-[35%] flex-[35%]'>
                <div className='flex flex-col flex-wrap items-center justify-center'>
                  <div className='text-black leading-6 flex gap-1 text-center text-2xl font-bold tracking-tight'>
                    <span className='current'>{average}</span>
                    <span className='seperate'>/</span>
                    <span className='limit'>5</span>
                  </div>
                  <StarRatings
                    starRatedColor='#FFCD4B'
                    numberOfStars={5}
                    rating={average}
                    starDimension='13px'
                    starSpacing='1px'
                    svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
                    svgIconViewBox='0 0 40 40'
                  />
                  <div className='leading-5'>
                    <span className='text-sm font-extrabold tracking-tight text-neutral-700'>
                      {sum}
                    </span>
                    <span className='text-sm font-normal tracking-tight text-neutral-700'>
                      {' '}
                      đánh giá
                    </span>
                  </div>
                </div>
                <div className='absolute right-0 top-[50%] h-[100%] w-px translate-y-[-50%] rounded-[10px] bg-gray-200'></div>
              </div>
              {reviewGalleryData &&
                renderLightBox({
                  slides: reviewGalleryData?.map((e: any) => {
                    const width = 475 * 4
                    const height = 475 * 4
                    return {
                      src: e?.value || e,
                      width,
                      height,
                      srcSet: breakpoints.map(breakpoint => {
                        const breakpointHeight = Math.round(
                          (height / width) * breakpoint
                        )
                        return {
                          src: e?.value || e,
                          width: breakpoint,
                          height: breakpointHeight,
                        }
                      }),
                    }
                  }),
                  index: indexGallery,
                })}
              <div className='star_lines max-w-[65%] flex-[65%]'>
                {newArrayPoint &&
                  newArrayPoint.reverse().map((key, index) => (
                    <div
                      className='star_line flex items-center gap-2 pr-3'
                      key={index}
                    >
                      <div className='star_type flex w-5 items-center gap-[3px] text-xs'>
                        <span>{key.point}</span>
                        <Star />
                      </div>
                      <div className='prog flex-auto relative h-1.5 w-full rounded-[10px] bg-zinc-300'>
                        <div
                          className='prog_bar absolute h-1.5 rounded-[10px] bg-amber-300'
                          style={{
                            width:
                              sum === 0
                                ? '100%'
                                : (key.value / sum) * 100 + '%',
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className='listReviewImage mt-3'>
              <div className='mb-3 w-full'>
                <span className='text-sm font-bold leading-[18px] tracking-tight text-zinc-800'>
                  Tất cả hình ảnh{' '}
                </span>
                <span className='text-sm font-normal italic leading-[18px] tracking-tight text-zinc-800'>
                  ({extractedDataImage?.length} hình)
                </span>
              </div>
              <ul className='listImageReview flex w-full items-center justify-start gap-x-2'>
                {extractedDataImage?.slice(0, 5)?.map((e, i) => {
                  return (
                    <li className='max-w-[20%] flex-[20%]' key={i + e?.index}>
                      <div
                        onClick={() => openReviewGallery(extractedDataImage, i)}
                        key={i}
                        className='relative block overflow-hidden rounded-sm'
                      >
                        <ImageOptimize
                          src={e?.value || ''}
                          width={90}
                          height={90}
                          className={'aspect-square w-full object-cover'}
                          alt={'/'}
                        />
                        {i == 4 && (
                          <span className='absolute left-0 top-0 flex h-full w-full items-center justify-center bg-dark-900/50 px-0.5 text-center text-xs leading-tight text-white'>
                            Xem tất cả
                          </span>
                        )}
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
            <Tab.Group as='div'>
              <Tab.List
                className='filterReview mt-4 flex items-center gap-2'
                as='div'
              >
                <div className='filterItems flex-auto flex flex-wrap w-full justify-start gap-2'>
                  {filterAttr.map((e, i) => {
                    return (
                      <Tab as={Fragment} key={i}>
                        {({ selected }) => (
                          <button
                            onClick={() => changeDataReview(e)}
                            className={`${
                              selected ? 'border-blue' : 'border-white-500'
                            } flex h-8 text-dark-500 items-center gap-1 rounded-[60px] border bg-white-500 px-3 outline-none hover:border-blue hover:text-blue`}
                          >
                            {selected ? <IconCheckBlue /> : ''}
                            <span className='text-sm leading-[18px] tracking-tight'>
                              {e?.name}
                            </span>
                          </button>
                        )}
                      </Tab>
                    )
                  })}
                </div>
              </Tab.List>

              <Tab.Panels as='div'>
                {filterAttr.map((e, i) => {
                  return (
                    <Tab.Panel key={i}>
                      <div className='comments mt-2 flex flex-wrap gap-3 flex-col'>
                        {filterItemtReview?.map((e, i) => {
                          return (
                            <div className='commentBox relative ' key={i}>
                              <div className=' relative bg-white-500 rounded-lg p-3'>
                                <h5 className='text-black text-sm font-bold'>
                                  {e?.user?.name}
                                </h5>

                                <div className='timeRate flex items-center gap-2'>
                                  <StarRatings
                                    starRatedColor='#FFCD4B'
                                    numberOfStars={5}
                                    rating={e?.point}
                                    starDimension='10px'
                                    starSpacing='0px'
                                    svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
                                    svgIconViewBox='0 0 40 40'
                                  />
                                  <p className=' text-xs font-normal italic tracking-tight text-neutral-500'>
                                    {dayjs(e?.createdAt).format(
                                      'HH:mm:ss - DD/MM/YYYY'
                                    )}
                                  </p>
                                </div>
                                <div className='text-black text-sm font-normal'>
                                  {e?.content}
                                </div>
                                <ul className='text-black mt-1.5 flex gap-2 text-sm font-normal'>
                                  {e?.images
                                    .slice(0, 5)
                                    .map((imageItem, imageIndex) => {
                                      return (
                                        <li
                                          className='aspect-square max-w-[60px] flex-[60px] overflow-hidden rounded-sm'
                                          key={imageIndex}
                                          onClick={() =>
                                            openReviewGallery(
                                              e?.images,
                                              imageIndex
                                            )
                                          }
                                        >
                                          <ImageOptimize
                                            src={imageItem || ''}
                                            width={60}
                                            height={60}
                                            alt={e?.content}
                                            className='h-full w-full object-cover'
                                          />
                                        </li>
                                      )
                                    })}
                                </ul>
                              </div>
                              {e?.staff && e?.answerContent && (
                                <div className='mt-1 ml-3 bg-indigo-50 rounded-lg px-3 pt-2 pb-3'>
                                  <div className='text-black flex items-center gap-2 text-sm font-bold leading-5'>
                                    <span>
                                      {systemConfig?.authorDefault ||
                                        'Quản trị viên'}
                                    </span>
                                    <span className='flex h-3 w-3 items-center justify-center overflow-hidden rounded-full bg-red'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width={8}
                                        height={8}
                                        viewBox='0 0 11 11'
                                        fill='none'
                                      >
                                        <g clipPath='url(#clip0_590_6242)'>
                                          <path
                                            d='M10.5176 2.15709C10.2082 1.84728 9.70582 1.84747 9.39601 2.15709L4.34787 7.20542L2.10419 4.96176C1.79438 4.65195 1.29217 4.65195 0.98236 4.96176C0.672547 5.27158 0.672547 5.77378 0.98236 6.08359L3.78684 8.88807C3.94165 9.04288 4.14464 9.12048 4.34765 9.12048C4.55067 9.12048 4.75386 9.04307 4.90867 8.88807L10.5176 3.2789C10.8275 2.9693 10.8275 2.46689 10.5176 2.15709Z'
                                            fill='white'
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id='clip0_590_6242'>
                                            <rect
                                              width={10}
                                              height={10}
                                              fill='white'
                                              transform='translate(0.75 0.522705)'
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </span>
                                  </div>
                                  <div className='text-xs font-normal italic tracking-tight text-neutral-500'>
                                    {dayjs(e?.answerUpdatedAt).format(
                                      'HH:mm:ss - DD/MM/YYYY'
                                    )}
                                  </div>
                                  {e?.answerContent ? (
                                    <div className='text-black text-sm font-normal leading-5'>
                                      {e?.answerContent}
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                  <ul className='text-black mt-1 flex gap-2 text-base font-normal'>
                                    {e?.answerImages &&
                                      e?.answerImages
                                        .slice(0, 5)
                                        .map((imageItem, imageIndex) => {
                                          return (
                                            <li
                                              className='aspect-square max-w-[60px] flex-[60px] overflow-hidden rounded-sm'
                                              key={imageIndex}
                                              onClick={() =>
                                                openReviewGallery(
                                                  e?.answerImages,
                                                  imageIndex
                                                )
                                              }
                                            >
                                              <ImageOptimize
                                                src={imageItem || ''}
                                                width={60}
                                                height={60}
                                                alt={e?.content}
                                                className='h-full w-full object-cover'
                                              />
                                            </li>
                                          )
                                        })}
                                  </ul>
                                </div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </Tab.Panel>
                  )
                })}
              </Tab.Panels>
            </Tab.Group>
          </div>
        )}
      </div>
    </DrawBottom>
  )
}

export default ModalListReview
